module.exports = __webpack_public_path__ + "img/pcgg.34fd7aa5.png";